import { RequestAction } from '@redux-requests/core';
import { actionPrefixer } from 'shared/utils/utils';

const prefix = actionPrefixer('SOURCE');
/*
    Action Types
*/

export const FETCH_SOURCE_MAPPINGS = prefix('FETCH_SOURCE_MAPPINGS');

export const FETCH_SOURCE_STATUS = prefix('FETCH_SOURCE_STATUS');

export const VIEW_SOURCE = prefix('VIEW_SOURCE');
export const SET_SOURCE_TO_VIEW = prefix('SET_SOURCE_TO_VIEW');

/*
    Actions
*/

// Source Mappings are used to map source keys, used for icons (for now) to their respective enclaves
export const fetchSourceMappings = (): RequestAction => ({
    type: FETCH_SOURCE_MAPPINGS,
    request: {
        method: 'GET',
        url: '/services/entity-reports/source-mappings',
    },
});
